<template>
  <div>
    <div class="page-title">新增練習</div>
    <div class="page-box">
      <practiceFrom ref="ruleForm" :formLabelAlign="formLabelAlign"></practiceFrom>
      <div>請注意：標有 (<span class="star-mark">*</span>) 的為必填項。</div>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="backIndexPage">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {addPractises} from '@/api/practises'
import practiceFrom from "./components/practiceFrom.vue";
export default {
  components: { practiceFrom },
  data() {
    return {
      formLabelAlign: {
        id: 0,
        number: null,
        lang: 0,
        type: 0,
        guideVideoUrl: '',
        guideImageUrl: '',
        randomNumber: null,
        passScore: null,
        isRandom: true,
        questions: [],
      },
    };
  },
  methods: {
    onSubmit() {
       this.$refs.ruleForm.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.addPractises()
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
    },
    addPractises(){
      addPractises(this.formLabelAlign).then(()=>{
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.$router.push({ name: 'practice' })
      })
    },
    backIndexPage() {
      this.$router.push('/practice')
    }
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
}
</style>